// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-mdx-page-layout-tsx": () => import("./../src/components/MdxPageLayout.tsx" /* webpackChunkName: "component---src-components-mdx-page-layout-tsx" */),
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-confirmed-tsx": () => import("./../src/pages/confirmed.tsx" /* webpackChunkName: "component---src-pages-confirmed-tsx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-thanks-tsx": () => import("./../src/pages/thanks.tsx" /* webpackChunkName: "component---src-pages-thanks-tsx" */)
}

